var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox-default"},[_c('input',{attrs:{"type":"checkbox","id":_vm.params.node.data.checkBoxId},domProps:{"checked":_vm.params.node.data.checked == true ? true : false},on:{"click":function($event){return _vm.cellClicked($event, _vm.params)}}}),_c('label',{attrs:{"for":_vm.params.node.data.checkBoxId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }